import { render, staticRenderFns } from "./ticketInfo.vue?vue&type=template&id=1342c3c8"
import script from "./ticketInfo.vue?vue&type=script&lang=js"
export * from "./ticketInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports